/** @format */

import {ArtworkColumn} from './table_coulmns/artwork_column';
import {ActionColumn} from './table_coulmns/action_column';
import DateOnly from '../../../../utilities/format/date';
import {OrderBasicDetails} from 'frontier-components';
import {If} from 'frontier-utilities';
import {Link} from 'react-router-dom';
import React from 'react';

export function designListUngroupedTableRows(params) {
    const {isShowingThumbnails, filteredDesigns} = params;

    const rows = filteredDesigns.map(design_order => {
        return {
            key: design_order.id,
            artwork: (
                <ArtworkColumn
                    isShowingThumbnails={isShowingThumbnails}
                    designOrder={design_order}
                />
            ),
            type: (
                <div className="m-0 p-0">
                    <div className="artwork-column-27ux__table-cell">
                        {design_order.order.product_type_label}
                    </div>
                </div>
            ),
            last_order_id: (
                <div>
                    <div className="artwork-column-27ux__table-cell">
                        <Link to={'/account/orders/view/' + design_order.order_id}>
                            <u>{design_order.order_id}</u>
                        </Link>
                        <If condition={!!design_order.order.po_number}>
                            <p className="color-structure-darker">
                                <b>PO:</b> #{design_order.order.po_number}
                            </p>
                        </If>
                    </div>
                </div>
            ),
            date: (
                <div>
                    <div className="artwork-column-27ux__table-cell">
                        <DateOnly>{design_order.created}</DateOnly>
                    </div>
                </div>
            ),
            description: (
                <div className="table-column-76tg__description">
                    <div className="artwork-column-27ux__table-cell">
                        <OrderBasicDetails order={design_order.order} />
                    </div>
                </div>
            ),
            action: <ActionColumn designOrder={design_order} />
        };
    });

    return rows;
}
